<script setup>
import stLogo from '../assets/logo-large.svg'
import { computed, onMounted, ref, watch } from 'vue'
import ButtonComponent from '@/components/ButtonComponent.vue'

const props = defineProps({
  brandLogo: String,
  deviceInfo: Object
})
// Constants for progress animation
const PROGRESS_INTERVAL_MS = 60
const FAST_PROGRESS_THRESHOLD = 80
const MEDIUM_PROGRESS_THRESHOLD = 95
const FAST_INCREMENT = 10
const MEDIUM_INCREMENT = 5
const SLOW_INCREMENT = 1
const MAX_PROGRESS = 99

const percentage = ref(0)
const showStartButton = ref(false)
const progressStarted = ref(false)
const isWechat = props.deviceInfo.isWechat()

const emit = defineEmits(['initializeApp'])

const mainLogo = computed(() => props.brandLogo ?? stLogo)

const updateProgress = () => {
  if (progressStarted.value) {
    return
  }

  progressStarted.value = true
  const interval = window.setInterval(() => {
    if (percentage.value < FAST_PROGRESS_THRESHOLD) {
      percentage.value += FAST_INCREMENT
    } else if (percentage.value < MEDIUM_PROGRESS_THRESHOLD) {
      percentage.value += MEDIUM_INCREMENT
    } else {
      percentage.value += SLOW_INCREMENT
    }

    if (percentage.value >= 100) {
      percentage.value = MAX_PROGRESS
      clearInterval(interval)
    }
  }, PROGRESS_INTERVAL_MS)
}
const handleStartScanning = () => {
  updateProgress()
}

onMounted(() => {
  if (!isWechat) {
    updateProgress()
  }
})

watch(
  () => percentage.value,
  (newVal) => {
    if (newVal >= MAX_PROGRESS) {
      emit('initializeApp')
    }
  }
)

const scanButtonName = computed(() =>
  percentage.value > 0 ? 'authentication.opening' : 'authentication.start_scan'
)
</script>

<template>
  <div
    :class="[percentage > 0 ? 'gap-44' : 'gap-56']"
    class="h-screen flex flex-col justify-center items-center bg-[var(--background)] text-[var(--text)] rtl:text-right"
  >
    <div class="flex flex-col items-center gap-3">
      <img :src="mainLogo" alt="" class="h-full w-48" crossorigin />

      <p
        v-if="!isWechat || percentage > 0"
        class="mt-3.5 text-lg text-[var(--text)]"
      >
        {{ $t('launch') }} {{ percentage }}%
      </p>
    </div>

    <ButtonComponent
      v-if="isWechat"
      :buttonName="scanButtonName"
      :disabled="percentage > 0"
      :is-wechat="isWechat"
      :onClick="handleStartScanning"
    />
  </div>
</template>
